import { getLocalCalendarDayString, logTermsAcceptance, writeTermsAcceptanceDailyCache, } from '@ibk/shared-utils';
import { buildPendingSnapshotFromTermsStatus, buildPendingTermsState, closeGateAndSetReady, createEffectCommitScope, resolvePlatformTermsAcceptanceFeatureEnabled, } from './termsAcceptanceGateUtils';
function applyTermsStatusSuccessToGate(result, userIdRef, setters) {
    const userId = userIdRef.current;
    const pendingSnapshot = buildPendingSnapshotFromTermsStatus(result);
    writeTermsAcceptanceDailyCache({
        day: getLocalCalendarDayString(),
        serverAccepted: result.accepted,
        ...(userId != null && userId !== '' ? { userId } : {}),
        ...(pendingSnapshot != null ? { pendingSnapshot } : {}),
    });
    setters.setPendingTerms(buildPendingTermsState(result.term, result.termsHtml));
    const openModal = !result.accepted;
    setters.setModalOpen(openModal);
    if (openModal) {
        const term = result.term;
        logTermsAcceptance('gate.modal_open', {
            accepted: result.accepted,
            hasTerm: Boolean(term?.termId),
            hasTermsHtml: Boolean(result.termsHtml),
            hasDocumentLink: Boolean(term?.sourceType === 'LINK' && term.sourceValue.trim().length > 0),
        });
    }
}
export function startRestorableDailyCacheEffect(dailyCache, userIdRef, getFeatureFlagsRef, isFeatureFlagWhiteListedRef, setters) {
    const scope = createEffectCommitScope();
    void (async () => {
        try {
            const platformTermAcceptanceEnabled = await resolvePlatformTermsAcceptanceFeatureEnabled(getFeatureFlagsRef.current, isFeatureFlagWhiteListedRef.current, userIdRef.current);
            scope.ifActive(() => {
                if (!platformTermAcceptanceEnabled) {
                    closeGateAndSetReady(setters);
                    return;
                }
                const snap = dailyCache.pendingSnapshot;
                const termFromSnap = snap.term;
                setters.setPendingTerms(buildPendingTermsState(termFromSnap, snap.termsHtml));
                setters.setModalOpen(true);
                setters.setGateReady(true);
            });
        }
        catch (cause) {
            scope.ifActive(() => {
                logTermsAcceptance('gate.feature_flags_fetch_error', { description: 'Falha ao obter feature flags; termos não exibidos até nova tentativa.' }, 'warn', cause);
                closeGateAndSetReady(setters);
            });
        }
    })();
    return scope.dispose;
}
export function startFreshTermsStatusEffect(userIdRef, getFeatureFlagsRef, isFeatureFlagWhiteListedRef, triggerStatusRef, setters) {
    const scope = createEffectCommitScope();
    void (async () => {
        try {
            const platformTermAcceptanceEnabled = await resolvePlatformTermsAcceptanceFeatureEnabled(getFeatureFlagsRef.current, isFeatureFlagWhiteListedRef.current, userIdRef.current);
            if (!platformTermAcceptanceEnabled) {
                scope.ifActive(() => closeGateAndSetReady(setters));
                return;
            }
            const result = await triggerStatusRef.current().unwrap();
            scope.ifActive(() => applyTermsStatusSuccessToGate(result, userIdRef, setters));
        }
        catch (cause) {
            scope.ifActive(() => {
                logTermsAcceptance('gate.status_fetch_error', {
                    description: 'Falha ao obter status de aceite de termos; home segue sem modal (fail-open).',
                }, 'error', cause);
                setters.setPendingTerms(null);
                setters.setModalOpen(false);
            });
        }
        finally {
            scope.ifActive(() => setters.setGateReady(true));
        }
    })();
    return scope.dispose;
}
